import { Injectable } from '@angular/core';

import { IBalancesResponse } from '@ib-shared/interfaces/balances-response.intf';
import { IDashboardTransactionsResponse } from '@ib-shared/interfaces/dashboard-table-row.intf';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DashboardStateService {
  // modals
  public showTransferModal$ = new BehaviorSubject<boolean>(false);
  public showDocsModal$ = new BehaviorSubject<boolean>(false);

  // balances
  public balances$ = new BehaviorSubject<IBalancesResponse | null>(null);
  public balancesLoading$ = new BehaviorSubject<boolean>(false);

  // transactions
  public tableRowsLoading$ = new BehaviorSubject<boolean>(false);
  public tableRows$ =
    new BehaviorSubject<IDashboardTransactionsResponse | null>(null);
}
